import React, { useState, useEffect } from "react"

import fetchJsonp from "fetch-jsonp"
import SmartFeedJobAlerts from "./SmartFeedJobAlerts"

import "url-search-params-polyfill"

require("es6-promise").polyfill()

let prevCount = 0
let currentCount = 0
let keywordTime = null

const slugify = function slugify(text) {
  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters

    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
}

const SmartFeedFiltersComponent = (props) => {
  const id = 1
  const [vacancy, setVacancy] = useState([])
  const [vacancyTitle, setVacancyTitle] = useState("Loading vacancies...")
  const [isIinitialLoad, setIsIinitialLoad] = useState(true)
  const [initialLoading, setInitialLoading] = useState(true)

  // Filter States
  const [locationFilter, setLocationFilter] = useState([])
  const [regionFilter, setRegionFilter] = useState([])
  const [categoryFilter, setCategoryFilter] = useState([])
  const [industryFilter, setIndustryFilter] = useState([])
  const [postingTypeFilter, setPostingTypeFilter] = useState([])
  const [jobTypeFilter, setJobTypeFilter] = useState([])
  const [keywordFilter, setKeywordFilter] = useState([])
  const [autoCompleteFilter, setAutoCompleteFilter] = useState([])
  const [autocompleteListHide, setAutocompleteListHide] = useState(true)
  const [filterState, setFilterState] = useState({})
  const [vacsCount, setVacsCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadMoreText, setLoadMoreText] = useState(false)

  // Button filters
  const [careersNavState, setCareersNavState] = useState("careers")

  const addActiveClassnameToNav = function addActiveClassnameToNav(stateName) {
    if (stateName === careersNavState) {
      return "VF_Nav_Item_Active"
    }

    return ""
  }

  let groupOrIdParam = "id"

  if (props.group) {
    groupOrIdParam = "group"
  }

  function removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b)
  }

  const fetchFilters = async (name, setState, label) => {
    try {
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/" +
          name +
          "?" +
          groupOrIdParam +
          "=" +
          props.apiKey
      )
        .then(function (response) {
          return response.json()
        })
        .then(function (jsonList) {
          let temp = ["All " + label]

          setState(temp.concat(removeDuplicates(jsonList)))

          props.setVacancyLoading(false)
        })
        .catch(function (ex) {
          setLoading(false)
          console.log(ex, "error")
        })
    } catch (error) {
      setLoading(false)
      console.log(error.message, "error")
    }
  }

  const fetchVacancies = async (
    state,
    name,
    e,
    loadMore,
    postingTypeSelection
  ) => {
    let postingTypeSelectionValue = careersNavState

    if (careersNavState !== postingTypeSelection && postingTypeSelection) {
      postingTypeSelectionValue = postingTypeSelection
    }

    // State of filters, Name of searched filter, event, load more boolean
    setLoadMoreText("Loading.....")

    if (name) {
      prevCount = 0
      currentCount = 0
    }

    let temp = state

    if (name) {
      if (e) {
        if (e.target && e.target.value.includes(name)) {
          e.target.value = ""
        }
      }

      if (name === "autocomplete") {
        temp.latitude = e.lat
        temp.longitude = e.long
        temp.distance = e.distance
        temp.unit = "Miles"
      } else if (name === "location") {
        if (e.target.value.includes("All ")) {
          delete temp.location
        } else {
          temp.location = e.target.value
        }
      } else if (name === "keywords") {
        temp.keywords = e.target.value
      } else if (name === "region") {
        if (e.target.value.includes("All ")) {
          delete temp.region
        } else {
          temp.region = e.target.value
        }
      } else if (name === "category") {
        if (e.target.value.includes("All ")) {
          delete temp.category
        } else {
          temp.category = e.target.value
        }
      } else if (name === "industry") {
        if (e.target.value.includes("All ")) {
          delete temp.industrysector
        } else {
          temp.industrysector = e.target.value
        }
      } else if (name === "postingType") {
        if (e.target.value.includes("All ")) {
          delete temp.postingtype
        } else {
          temp.postingtype = e.target.value
        }
      } else if (name === "jobtype") {
        if (e.target.value.includes("All ")) {
          delete temp.jobtype
        } else {
          temp.jobtype = e.target.value
        }
      } else if (name === "jobtime") {
        if (e.target.value.includes("All ")) {
          delete temp.jobtime
        } else {
          temp.jobtime = e.target.value
        }
      } else if (name === "country") {
        if (e.target.value.includes("All ")) {
          delete temp.country
        } else {
          temp.country = e.target.value
        }
      } else if (name === "companySearch") {
        if (e.target.value.includes("All ")) {
          delete temp.CompanySearch
        } else {
          temp.CompanySearch = e.target.value
        }
      } else if (name === "reset") {
        delete temp.CompanySearch
        delete temp.country
        delete temp.jobtime
        delete temp.jobtype
        delete temp.postingtype
        delete temp.industrysector
        delete temp.category
        delete temp.region
        delete temp.latitude
        delete temp.longitude
        delete temp.distance
        delete temp.unit

        if (document && document.getElementById("Keywords")) {
          document.getElementById("Keywords").value = ""
        }
      }

      setFilterState(temp)
    }

    function getAdvertData(jobs) {
      return Promise.all(
        jobs.slice(prevCount, currentCount).map(async (id) => {
          return fetchJsonp(
            "https://sf.vacancy-filler.co.uk/CareerPage/GetItem?id=" + id
          ).then(function (response) {
            return response.json()
          })
        })
      )
    }

    if (!loadMore) {
      prevCount = 0
      currentCount = 0
      setLoading(true)
    }

    try {
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/GetResultList?id=" +
          props.apiKey +
          "&" +
          "sortby=postingdate" +
          "&" +
          "sortdir=desc" +
          "&" +
          "postingtype=" +
          postingTypeSelectionValue +
          "&" +
          buildQuery(temp)
      )
        .then(function (response) {
          return response.json()
        })
        .then(async function (jsonList) {
          prevCount = currentCount
          currentCount = currentCount + 10

          await getAdvertData(jsonList).then(function (data) {
            if (loadMore) {
              setVacancy(vacancy.concat(data))
            } else {
              setVacancy(data)
            }

            if (jsonList.length === 0) {
              setVacancyTitle(
                "Showing " +
                  jsonList.length +
                  " positions matching your search."
              )
            } else {
              setVacancyTitle("Showing " + jsonList.length + " positions.")
            }

            setInitialLoading(false)

            setLoading(false)

            setLoadMoreText("Load More")
            setVacsCount(jsonList.length)
          })
        })
    } catch (error) {
      setLoading(false)
      console.log(error.message, "error")
    }
  }

  const chooseGeoLocation = function chooseGeoLocation(lat, long, distance) {
    setAutocompleteListHide(true)
    fetchVacancies(
      filterState,
      "autocomplete",
      { lat: lat, long: long, distance: distance },
      false
    )
  }

  const renderFilter = function renderFilter(data, label, stateName) {
    if (label === "Keyword Search") {
      return (
        <div className="vf-filter ginput_container ginput_container_text">
          <label aria-label={label} htmlFor={"Keywords"}>
            {label}:{" "}
          </label>
          <input
            defaultValue={filterState[stateName]}
            onChange={(e) => {
              e.persist()
              keywordSearchChange(filterState, stateName, e, false)
            }}
            className="VF-form-control onchange-search form-control"
            id="Keywords"
            name="Keywords"
            placeholder="Enter keywords"
            type="text"
          />
        </div>
      )
    } else if (label === "Search Location") {
      return (
        <div className="vf-filter ginput_container ginput_container_text">
          <label aria-label={label} htmlFor={"AutocompleteLocInput"}>
            {label}:{" "}
          </label>
          <div className="vf-filter-loc-complete-wrap">
            <input
              value={filterState[stateName]}
              onChange={(e) =>
                autocompleteSearchChange(filterState, label, e, false)
              }
              className="VF-form-control onchange-search form-control"
              id="AutocompleteLocInput"
              name="AutocompleteLocInput"
              placeholder="Enter postcode, town or city"
              type="text"
            />
            {!autocompleteListHide &&
              data &&
              Array.isArray(data) &&
              data.length > 0 && (
                <div className="vf-filter-loc-complete-list">
                  {data.map((loc, i) => (
                    <div
                      key={i}
                      onClick={() =>
                        chooseGeoLocation(loc.latitude, loc.longitude, 10)
                      }
                    >
                      {loc.displayName}
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
      )
    } else {
      return (
        <div className="vf-filter ginput_container ginput_container_text">
          <label aria-label={label} htmlFor={"select-" + stateName}>
            {label}:{" "}
          </label>
          <select
            className="form-control"
            value={filterState[stateName] || data[0]}
            onChange={(e) => fetchVacancies(filterState, stateName, e, false)}
            name={"select-" + stateName}
            id={"select-" + stateName}
          >
            {data.map((item, i) => (
              <option key={i} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      )
    }
  }

  const clickCurrentVacancies = function clickCurrentVacancies() {
    setCareersNavState("careers")
    fetchVacancies(filterState, undefined, undefined, false, "careers")
  }

  const clickRegisterVacancies = function clickRegisterVacancies() {
    setCareersNavState("register")
    fetchVacancies(filterState, undefined, undefined, false, "register")
  }

  const clickAlertsVacancies = function clickAlertsVacancies() {
    setCareersNavState("alerts")
  }

  const loadMore = function loadMore() {
    fetchVacancies(filterState, undefined, undefined, true)
  }

  const resetVacs = function resetVacs() {
    fetchVacancies({}, "reset", undefined, false)
  }

  const searchVacs = function searchVacs() {
    fetchVacancies({}, "search", undefined, false)
  }

  const autocompleteSearchChange = function autocompleteSearchChange(
    state,
    name,
    e,
    loadMore
  ) {
    setAutocompleteListHide(false)

    let val = e.currentTarget.value

    if (e.currentTarget.value.length > 3) {
      // Do api call to get key
      fetchJsonp(
        "https://sf.vacancy-filler.co.uk/CareerPage/GetLocationAPIKey?id=" +
          props.apiKey
      )
        .then(function (response) {
          return response.json()
        })
        .then(function (geoKey) {
          // Do api call to get locs
          fetch(
            "https://geocoding.vacancy-filler.co.uk/api/V2/exact/?apikey=" +
              geoKey.key +
              "&search=" +
              encodeURIComponent(val)
          )
            .then((res) => res.json())
            .then((result) => {
              setAutoCompleteFilter(result.locationResults)
            })
        })
    }
  }

  const keywordSearchChange = function keywordSearchChange(
    state,
    name,
    e,
    loadMore
  ) {
    clearTimeout(keywordTime)

    keywordTime = setTimeout(() => {
      fetchVacancies(state, name, e, loadMore)
    }, 500)
  }

  const getSummary = function getSummary(summary, description) {
    if (summary) {
      return summary
    } else {
      let alteredDescription = description.replace(/<[^>]*>?/gm, "")
      let tempSummary = alteredDescription.substring(0, 397)
      if (tempSummary.length === 397) {
        tempSummary += "..."
      }
      return tempSummary
    }
  }

  const calculateSalary = function calculateSalary(
    Currency,
    SalaryFrom,
    SalaryTo,
    SalaryType,
    SalaryPeriod
  ) {
    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    let NewSalary
    let NewSalaryFrom
    let NewSalaryTo

    let currencyFormatted = Currency

    if (Currency === "&pound;") {
      currencyFormatted = "£"
    }

    if (SalaryTo === 0) {
      NewSalary = SalaryType
    } else if (SalaryFrom === SalaryTo) {
      if (SalaryFrom >= 1000) {
        // Remove decimals
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed())
      } else {
        // Add two decimals
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2))
      }
      NewSalary = NewSalaryFrom + " " + SalaryPeriod
    } else {
      if (SalaryFrom >= 1000) {
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed())
      } else {
        NewSalaryFrom =
          currencyFormatted + numberWithCommas(SalaryFrom.toFixed(2))
      }
      if (SalaryTo >= 1000) {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed())
      } else {
        NewSalaryTo = currencyFormatted + numberWithCommas(SalaryTo.toFixed(2))
      }

      NewSalary = NewSalaryFrom + " - " + NewSalaryTo + " " + SalaryPeriod
    }
    return NewSalary
  }
  const getImageFromRegionCards = function getImageFromRegionCards(region) {
    let jobCardRegionNoSpaces = region.replace(/[, ]+/g, "-")

    if (jobCardRegionNoSpaces === "Cheddar-Gorge-&-Caves") {
      return "Cheddar-Gorge-and-Caves"
    }

    return jobCardRegionNoSpaces
  }

  const FormatDateTime = function FormatDateTime(JSONDate) {
    // Set default values to avoid function breaking
    var expDate = new Date(parseInt(JSONDate.substr(6)))
    var dateFormatOptions = new Object({})
    dateFormatOptions.weekday = "long"
    dateFormatOptions.year = "numeric"
    dateFormatOptions.month = "short"
    dateFormatOptions.day = "numeric"
    return expDate.toLocaleDateString(undefined, dateFormatOptions)
  }

  const buildQuery = function buildQuery(data) {
    if (typeof data === "string") return data
    let query = []

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        query.push(
          encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
      }
    }

    return query.join("&")
  }

  useEffect(() => {
    setIsIinitialLoad(false)
    if (URLSearchParams) {
      var urlParams = new URLSearchParams(window.location.search)
      var entries = urlParams.entries()
    }
    let temp = {}
    for (let pair of entries) {
      temp[pair[0]] = pair[1]
    }

    setFilterState(temp)

    const timeOut = setTimeout(() => {
      fetchVacancies(temp, undefined, undefined, false)
      if (props.group === true) {
        fetchFilters("GetLocationListByGroup", setLocationFilter, "Locations") // Locations
        fetchFilters("GetRegionListByGroup", setLocationFilter, "Regions") // Regions
        fetchFilters("GetCategoryListByGroup", setCategoryFilter, "Categories") // Categories
        fetchFilters("GetIndustryListByGroup", setIndustryFilter, "Industries") // Industries
        fetchFilters(
          "GetPostingTypesListByGroup",
          setPostingTypeFilter,
          "Posting Types"
        ) // Posting Types
        fetchFilters("GetJobTypeListByGroup", setJobTypeFilter, "Job Types") // Job Types
      } else {
        fetchFilters("GetLocations", setLocationFilter, "Locations") // Locations
        fetchFilters("GetRegions", setRegionFilter, "Locations") // Regions
        fetchFilters("GetCategories", setCategoryFilter, "Categories") // Categories
        fetchFilters("GetIndustries", setIndustryFilter, "Industries") // Industries
        fetchFilters("GetPostingTypes", setPostingTypeFilter, "Posting Types") // Posting Types
        fetchFilters("GetJobTypes", setJobTypeFilter, "Job Types") // Job Types
      }
    }, 50)
    return () => clearTimeout(timeOut)
  }, [])

  return (
    <div id="VF_vacancies">
      {!props.vacancyLoading && (
        <div className="row VF_vacancies_main_wrap">
          <div className="col-12">
            <div className="VF_Nav_Wrap">
              <div className="row VF_Nav_Items vacancies-nav ui item three stackable tabs menu">
                <button
                  id="VF_Nav_Item_Current"
                  onClick={() => clickCurrentVacancies()}
                  className={
                    "top_nav_click_careers vf_addon_disable vacancies-nav__link item col-12 col-xs-12 col-md-4 VF_Nav_Item VF_Nav_Item_Current " +
                    addActiveClassnameToNav("careers")
                  }
                >
                  Current Vacancies
                </button>
                <button
                  id="VF_Nav_Item_Register"
                  onClick={() => clickRegisterVacancies()}
                  className={
                    "top_nav_click_careers vf_addon_disable vacancies-nav__link item col-12 col-xs-12 col-md-4 VF_Nav_Item VF_Nav_Item_Register " +
                    addActiveClassnameToNav("register")
                  }
                >
                  Register your interest
                </button>
                <button
                  id="VF_Nav_Item_Alerts"
                  onClick={() => clickAlertsVacancies()}
                  className={
                    "top_nav_click_careers vf_addon_disable vacancies-nav__link item col-12 col-xs-12 col-md-4 VF_Nav_Item VF_Nav_Item_Alerts " +
                    addActiveClassnameToNav("alerts")
                  }
                >
                  Sign up to Job Alerts
                </button>
              </div>
            </div>

            {careersNavState !== "alerts" ? (
              <div className="main-section">
                <div className="row search-container-wrap">
                  <div className="search-container col-xs-12 col-12 col-md-4">
                    <div className="VF_filter_form">
                      <h3 className="search-title">Filter results by:</h3>

                      <div className="row VF_filter_form_row">
                        <div className="col-xs-12 col-12 VF_filter_form_item">
                          {renderFilter(
                            keywordFilter,
                            "Keyword Search",
                            "keywords"
                          )}
                        </div>
                        <div className="col-12 col-4-m VF_filter_form_item">
                          {renderFilter(
                            categoryFilter,
                            "Job Categories",
                            "category"
                          )}
                        </div>
                        <div className="col-12 col-4-m VF_filter_form_item">
                          {renderFilter(regionFilter, "Locations", "region")}
                        </div>
                        <div className="col-12 col-4-m VF_filter_form_item">
                          {renderFilter(jobTypeFilter, "Job Types", "jobtype")}
                        </div>
                      </div>
                      <div className="row VF_filter_form_row VF_filter_form_row_buttons">
                        <div className="col-xs-12 col-12 col-spacer-block"></div>
                        <div className="col-12 col-3-m">
                          {/* <button
                    className="btn btn-primary"
                    onClick={() => searchVacs()}
                  >
                    Search
                  </button> */}
                        </div>
                        <div className="col-12 col-3-m">
                          <button
                            id="reset_vacs"
                            className="btn btn-secondary"
                            onClick={() => resetVacs()}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="inner-content grid-section box-theme-2 joblist-section col-xs-12 col-md-8">
                    <div
                      id="VF-vacancies-wrapper"
                      className="col-12 VF_vacancies_list"
                    >
                      <div className="row">
                        {loading ? (
                          "Loading vacancies..."
                        ) : (
                          <>
                            <h3 className="search-title">{vacancyTitle}</h3>
                            {console.log(vacancy)}
                            {vacancy &&
                            vacancy !== [] &&
                            vacancy !== "[]" &&
                            !initialLoading ? (
                              <>
                                {vacancy && vacancy.length > 0 ? (
                                  vacancy.map((job, i) => (
                                    <div className="job-card card" key={i}>
                                      <div className="header">
                                        <a
                                          title={`Find out more about ${job.JobTitle}`}
                                          href={
                                            "/vacancies/vacancy/" +
                                            new Buffer(job.Id).toString(
                                              "base64"
                                            ) +
                                            "/" +
                                            slugify(job.JobTitle)
                                          }
                                        >
                                          {job.JobTitle}
                                        </a>
                                      </div>
                                      <div className="row">
                                        <div className="col-12 col-xs-12 col-md-12">
                                          <div className="content">
                                            {getSummary(
                                              job.Summary,
                                              job.Description
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-12 col-xs-12 col-md-12">
                                          <div className="row">
                                            <div className="col-12 col-xs-12 col-md-6">
                                              <div className="content top-content">
                                                <div className="location">
                                                  <span>
                                                    <span className="map marker alternate icon"></span>
                                                    Location:
                                                  </span>
                                                  {job.Location}
                                                </div>
                                                <div className="contract-type">
                                                  <span>
                                                    <span className="clock outline icon"></span>
                                                    Job Type:
                                                  </span>
                                                  {job.JobType}
                                                  {", "}
                                                  {job.JobTypeTime}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-12 col-xs-12 col-md-6">
                                              <div className="content">
                                                <div className="salary">
                                                  <span>
                                                    <span className="pound sign icon"></span>
                                                    Salary:
                                                  </span>
                                                  {calculateSalary(
                                                    job.Currency,
                                                    job.SalaryFrom,
                                                    job.SalaryTo,
                                                    job.SalaryType,
                                                    job.SalaryPeriod
                                                  )}
                                                </div>
                                                <div className="expiry">
                                                  <span>
                                                    <span className="calendar alternate outline icon"></span>
                                                    Closing Date:
                                                  </span>
                                                  {FormatDateTime(
                                                    job.ExpiryDate
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-12 col-xs-12">
                                          <div className="extra content">
                                            <a
                                              className="btn btn-primary "
                                              title={`Find out more about ${job.JobTitle}`}
                                              href={
                                                "/vacancies/vacancy/" +
                                                new Buffer(job.Id).toString(
                                                  "base64"
                                                ) +
                                                "/" +
                                                slugify(job.JobTitle)
                                              }
                                            >
                                              More details
                                              <span className="angle right icon"></span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="no-results">
                                    Sorry, we don't have any vacancies matching
                                    your search.
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="no-vacancies">
                                Loading vacancies...
                              </div>
                            )}

                            <div className="load-more-wrap col-12">
                              {currentCount < vacsCount && (
                                <a
                                  style={{
                                    textAlign: "center",
                                    display: "block",
                                    width: "100%",
                                  }}
                                  className="btn btn-secondary"
                                  onClick={() => loadMore()}
                                >
                                  {loadMoreText}
                                </a>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <SmartFeedJobAlerts
                apiKey={props.apiKey}
                gdprKey={props.gdprKey}
                group={props.group}
                location={true}
                region={true}
                category={true}
                industry={true}
                jobType={true}
                jobTime={true}
                CompanyGroupName={props.CompanyGroupName}
                VacancyPageBaseURL={props.VacancyPageBaseURL}
                ReturnToSearchURL={props.ReturnToSearchURL}
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SmartFeedFiltersComponent
